import { render, staticRenderFns } from "./ColumnsSelection.vue?vue&type=template&id=5d85cd0a&scoped=true"
import script from "./ColumnsSelection.vue?vue&type=script&lang=js"
export * from "./ColumnsSelection.vue?vue&type=script&lang=js"
import style0 from "./ColumnsSelection.vue?vue&type=style&index=0&id=5d85cd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85cd0a",
  null
  
)

export default component.exports